<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { authProviders, AuthProvider } from '@/composables/useAuth.ts'
import mdiEmail from '~icons/mdi/email'

type LoginProvider = (typeof authProviders)[number]

defineProps<{
  providers: readonly LoginProvider[]
}>()

const emit = defineEmits<{
  select: [provider: AuthProvider]
}>()

const { t } = useI18n()

// The one-time code is the only entry whose provider title ("E-mail") is not its button name.
function labelFor(provider: LoginProvider): string {
  return provider.id === 'email' ? t('common.one_time_code') : t(provider.title)
}
</script>

<template>
  <div class="d-flex flex-wrap ga-4">
    <v-btn
      v-for="provider in providers"
      :key="provider.id"
      variant="outlined"
      @click="emit('select', provider.id)"
    >
      <!-- Same rule as the primary button: the one-time code follows the text colour, the OAuth logos are brand images. -->
      <template
        v-if="provider.id === 'email'"
        #prepend
      >
        <v-icon :icon="mdiEmail" />
      </template>
      <template
        v-else-if="provider.image != null"
        #prepend
      >
        <img
          :src="provider.image"
          alt=""
          height="20"
        />
      </template>
      {{ labelFor(provider) }}
    </v-btn>
  </div>
</template>
